'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dMap$0024$002dEntry from "./java.util.-Map$-Entry.js";
var $p;
/** @constructor */
function $c_ju_HashMap$Node(key, hash, value, previous, next) {
  this.ek = null;
  this.hK = 0;
  this.dn = null;
  this.m3 = null;
  this.fw = null;
  this.ek = key;
  this.hK = hash;
  this.dn = value;
  this.m3 = previous;
  this.fw = next;
}
export { $c_ju_HashMap$Node as $c_ju_HashMap$Node };
$p = $c_ju_HashMap$Node.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
}
export { $h_ju_HashMap$Node as $h_ju_HashMap$Node };
$h_ju_HashMap$Node.prototype = $p;
$p.f = (function(that) {
  if ($j_java$002eutil$002e$002dMap$0024$002dEntry.$is_ju_Map$Entry(that)) {
    var a = this.ek;
    var b = that.ek;
    if (((a === null) ? (b === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(a, b))) {
      var a$1 = this.dn;
      var b$1 = that.dn;
      return ((a$1 === null) ? (b$1 === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(a$1, b$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  var improvedHash = this.hK;
  var o = this.dn;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $j_java$002elang$002e$002dObject.$dp_hashCode__I(o)));
});
$p.b = (function() {
  return ((this.ek + "=") + this.dn);
});
var $d_ju_HashMap$Node = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_HashMap$Node, "java.util.HashMap$Node", ({
  n7: 1,
  cj: 1
}));
export { $d_ju_HashMap$Node as $d_ju_HashMap$Node };
